import { gql, useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { ISetBonusRequest, ISetBonusResponse, SET_BONUS } from 'schemas';
import notification from 'services/notificationService';

import { TSetBonus } from './interfaces';

export const useSetBonus = (t: TTranslator<TLocalesKeys>): TSetBonus => {
  const [setDiscount] = useMutation<ISetBonusResponse, ISetBonusRequest>(
    SET_BONUS,
    {
      update: (cache, { data }) => {
        const user = data?.setBonus;

        if (!user) return;

        cache.writeFragment({
          id: cache.identify(user),
          data: user,
          fragment: gql`
            fragment deposit on User {
              deposit
            }
          `,
        });
      },
      onCompleted: () => {
        notification.info({
          t,
          title: t('bonuses.sets'),
          type: 'success',
          dismiss: 5,
        });
      },
    }
  );

  return setDiscount;
};
